import React, { useState, useEffect, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Box, Button, Typography, Avatar } from "@material-ui/core/"
import { closeUpdateUserDialog } from "actions/update-user-dialog"
import DialogsContainerDialog from "../DialogsContainer"
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto"
import Dropzone from "react-dropzone"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import MaskedMobileInput from "../../components/MaskedMobileInput"
import { updateUser } from "actions/user"
import ReusableFormControl from "../../components/ReusableFormControl"
import ReusableFormControlSelect from "components/ReusableFormControlSelect"
import cloudinary from "cloudinary-core"
import { openSnackBar } from "actions/snack-bar"
import { openResetPasswordDialog } from "actions/reset-password-dialog"
import { getOrgFields, getCurrentOrg } from "actions/organization"
import formatString from "format-string-by-pattern"
import { resizeImage } from "actions/upload"
import LoaderButton from "../../components/LoaderButton"
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const updateFields = [
  {
    name: "firstName",
    label: "First Name"
  },
  {
    name: "lastName",
    label: "Last Name"
  },
  {
    name: "phone",
    label: "Phone",
    inputProps: {
      inputComponent: MaskedMobileInput
    }
  },
  {
    name: "email",
    label: "Email"
  }
]

const updateUserSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  phone: Yup.string()
    .length(14)
    .required("Required"),
  email: Yup.string()
    .email("Invalid email")
    .required("Required")
    .nullable(),
  address: Yup.string().required("Required")
})

const reader = new FileReader()

const UpdateUserDialog = ({ fullScreen, classes, ...props }) => {
  const formRef = useRef()
  const dispatch = useDispatch()
  const { open, data, authenticatedUser, orgId } = useSelector(state => ({
    open: state.updateUserDialog.open,
    openFrom: state.updateUserDialog.openFrom,
    data: state.updateUserDialog.data,
    authenticatedUser: state.authentication.authenticatedUser,
    orgId: state.organization.currentOrg.id
  }))
  // const { getRootProps, getInputProps } = useDropzone()
  const [additionalFields, setAdditionalFields] = useState([])
  const [working, setWorking] = useState(false)
  const [defaultValues, setDefaultValues] = useState({})
  const handleClose = () => {
    dispatch(closeUpdateUserDialog())
  }

  useEffect(() => {
    dispatch(getOrgFields(orgId))
      .then(res => {
        const fields = res.body.data
        const additionalFieldsData = authenticatedUser.additionalFields
        const defaultValues = {}

        if (fields.length) {
          additionalFieldsData.map(data => {
            defaultValues[data.name.toLowerCase().replace(/\s/g, "")] =
              data.value
          })

          fields.map((field, index) => {
            const label = field.name
            const name = field.name.toLowerCase().replace(/\s/g, "")
            const options = field.options ? field.options.split(",") : null
            fields[index].label = label
            fields[index].name = name
            fields[index].options = options
            fields[index].id = field.id
          })

          setDefaultValues(defaultValues)
          setAdditionalFields(fields)
        }
      })
      .catch(error => {
        console.log(error)
        // dispatch(
        //   openSnackBar({ message: "Failed to get additional information" })
        // )
      })
  }, [orgId])

  useEffect(() => {
    if (authenticatedUser.additionalFields) {
      const defaultValues = {}
      const additionalFieldsData = authenticatedUser.additionalFields

      additionalFieldsData.map(data => {
        defaultValues[data.name.toLowerCase().replace(/\s/g, "")] = data.value
      })

      setDefaultValues(defaultValues)
    }
  }, [authenticatedUser])

  const handleUpdate = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }
  const handleOpenResetPassword = () => {
    dispatch(openResetPasswordDialog(true))
    dispatch(closeUpdateUserDialog())
  }

  return (
    <DialogsContainerDialog
      open={open}
      handleClose={handleClose}
      title="Update User"
      // subtitle="Look up a member by Phone or by Email"
      content={
        <Box className={classes.updateContainer}>
          <Formik
            innerRef={formRef}
            initialValues={{
              profileImage: authenticatedUser.profile_image
                ? authenticatedUser.profile_image
                : "",
              firstName: data.firstName,
              lastName: data.lastName,
              phone:
                data.phone &&
                formatString("(000) 000-0000", data.phone.replace("+1", "")),
              email: data.email,
              address: "Charleston",
              role: data.role,
              ...defaultValues
            }}
            validationSchema={updateUserSchema}
            onSubmit={values => {
              // console.log("ADD", additionalFields)
              const additionalFieldsData = {}
              const currentProfileImage = authenticatedUser.profile_image
                ? authenticatedUser.profile_image
                : ""
              let formData = {}

              Object.keys(values).map(key => {
                const match = additionalFields.find(field => field.name === key)
                if (match) {
                  additionalFieldsData[key] = {
                    value: values[key],
                    id: match.id,
                    name: match.label
                  }
                  delete values[key]
                }
              })

              formData = {
                ...values,
                additionalFields: additionalFieldsData,
                currentProfileImage: currentProfileImage
              }
              // console.log("FORMDATA:", formData)
              setWorking(true)
              dispatch(updateUser({ ...formData, id: data.id }))
                .then(res => {
                  setWorking(false)
                  dispatch(openSnackBar({ message: "User Updated!" }))
                  dispatch(closeUpdateUserDialog())
                  dispatch(getCurrentOrg())
                })
                .catch(error => {
                  setWorking(false)
                  dispatch(openSnackBar({ message: "Error" }))
                })
            }}
          >
            {formikProps => (
              <Form id="updateProfile" ref={formRef}>
                <Box>
                  <Box display="flex" justifyContent="center">
                    <Box className={classes.avatarContainer}>
                      <Avatar
                        className={classes.personPicture}
                        /* eslint-disable */
                        src={
                          formikProps.values.profileImage.split("/")[0] ===
                          "profile"
                            ? cl.url(formikProps.values.profileImage, {
                                width: 400,
                                crop: "scale"
                              })
                            : formikProps.values.profileImage
                        }
                        /* eslint-enable */
                      />
                      <Dropzone
                        onDrop={acceptedFiles => {
                          const file = acceptedFiles[0]
                          if (file !== undefined) {
                            // Set read as data url from uploaded file

                            reader.readAsDataURL(file)
                          }

                          reader.addEventListener("load", e => {
                            // fixOrientation(
                            //   reader.result,
                            //   { image: true },
                            //   function(fixed, image) {
                            dispatch(resizeImage(reader.result, 500, 500))
                              .then(res => {
                                formikProps.setFieldValue("profileImage", res)
                              })
                              .catch(error =>
                                dispatch(
                                  openSnackBar({
                                    message: "Image failed to upload."
                                  })
                                )
                              )
                            //   }
                            // )
                          })
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <section className={classes.addImageContainer}>
                            <div {...getRootProps()}>
                              <Button>
                                <input
                                  {...getInputProps()}
                                  accept="image/jpeg,image/jpg,image/png,application/pdf,image/x-eps"
                                />
                                <AddAPhotoIcon className={classes.iconColor} />
                              </Button>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    flexWrap="wrap"
                  >
                    <Box className={classes.personInformation}>
                      {updateFields.map((field, i) => {
                        const { name, label, inputProps = {} } = field
                        return (
                          <ReusableFormControl
                            key={i}
                            name={name}
                            label={label}
                            formikProps={formikProps}
                            inputProps={inputProps}
                            inputLabelClass={classes.labelTextColor}
                          />
                        )
                      })}
                    </Box>

                    <Box className={classes.additionalFieldsContainer}>
                      <Typography
                        className={classes.additionalFieldsTitle}
                        variant="h5"
                      >
                        Additional Fields
                      </Typography>
                      <Box>
                        <Box className={classes.fields}>
                          {additionalFields.map(field => (
                            <Box key={field.name} className={classes.field}>
                              {field.options === null ? (
                                <ReusableFormControl
                                  name={field.name}
                                  label={field.label}
                                  formikProps={formikProps}
                                  inputLabelClass={classes.labelTextColor}
                                />
                              ) : (
                                <ReusableFormControlSelect
                                  name={field.name}
                                  label={field.label}
                                  formikProps={formikProps}
                                  options={field.options}
                                  inputLabelClass={classes.labelTextColor}
                                />
                              )}
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* <button
                  id="submitProfileForm"
                  type="submit"
                  style={{ display: "none" }}
                /> */}
              </Form>
            )}
          </Formik>
        </Box>
      }
      buttons={
        <Box display="flex" className={classes.buttonsContainer}>
          <Button
            className={classes.resetButton}
            onClick={handleOpenResetPassword}
            variant="text"
          >
            Reset Password
          </Button>
          <Box display="flex">
            <Button
              onClick={handleClose}
              variant="text"
              className={classes.backButton}
            >
              back
            </Button>
            <Box display="flex">
              <LoaderButton
                working={working}
                color="primary"
                classes={{
                  button: classes.updateButton
                }}
                onClick={handleUpdate}
              >
                update
              </LoaderButton>
            </Box>
          </Box>
        </Box>
      }
    />
  )
}

export default withStyles(styles)(UpdateUserDialog)



// WEBPACK FOOTER //
// ./src/dialogs/UpdateUser/index.jsx